import withNavigate from "../../../routes/withNavigate.jsx";
import OrdersContainer from "./OrdersContainer.jsx";
import OrdersStore from "./OrdersStore.js";

export default OrdersStore(withNavigate(OrdersContainer));
